<div class="d-flex flex-column h-100" id="deviceSettings">
  <div class="data_header" id="deviceDataHeader">
    <div class="title" id="deviceTitle"><span i18n="@@device-settings.title">Device Settings</span></div>
  </div>

  <!-- Settings starts from here -->
  <!-- Passwords -->
  <div class="settings_block" id="deviceSettingBlock">
    <div class="settings_headers" id="deviceSettingHeaders">
      <img class="header_icon" alt="" />
      <span i18n="@@device-settings.passwords">Passwords</span>
    </div>
    <div class="settings_body password_section" id="settingsPwdSection">
      <div class="setting_info" id="settingInfo">
        <span i18n="@@device-settings.change-password-all-devices">Change password on <strong> all
            devices.</strong></span>
      </div>
      <div class="d-flex" id="changePwdPrimaryMain">
        <div class="d-flex flex-row" id="changePwdPrimarychild">
          <button type="button" [disabled]='!isRetailerId' class="btn btn-link" (click)="openChangePasswordModal('Primary')">
            <span i18n="@@device-settings.change-master-password-label">Change Primary Password</span>
          </button>
          <ng-template #popContent><span>
              <span i18n="@@device-settings.change-master-password-desc">This password allows you to access the
                On-device Admin Console (ODA).</span></span>
          </ng-template>
          <img class="info_icon" alt="hover for help" placement="auto" container="body" [ngbPopover]="popContent"
            triggers="mouseenter:mouseleave" />
        </div>
        <div class="d-flex flex-row" id="changePwdUninstall">
          <button type="button" [disabled]='!isRetailerId' class="btn btn-link ml-2" (click)="openChangePasswordModal('Uninstall')">
            <span i18n="@@device-settings.change-uninstall-password">Change Uninstall Password</span>
          </button>
          <ng-template #popContent2>
            <span i18n="@@device-settings.change-uninstall-password-desc">This password allows you to uninstall IPOS
              from a device.</span>
          </ng-template>
          <img class="info_icon" alt="hover for help" placement="auto" container="body" [ngbPopover]="popContent2"
            triggers="mouseenter:mouseleave" />
        </div>
      </div>
    </div>
  </div>

  <!-- Customizable button -->
  <div class="settings_block" id="settingsBlock">
    <div class="settings_headers" id="settingsHeaders">
      <img class="header_icon customButtonImg" alt="Customize buttons" />
      <span i18n="@@device-settings.customizable-button-title">Customizable Button</span>
    </div>
    <div class="settings_body" id="settingsBody">
      <div class="custom_btn_settings" id="customBtnSettings">
        <div id="customaizablebtn">
          <div class="setting_info" id="settingInfo">
            <span *ngIf='isNonConnectedUser' i18n="@@device-settings.customizable-button-desc">Change the functionality of the customizable
              button<strong> on all devices.</strong></span>
              <!-- <span *ngIf='!isNonConnectedUser'>Change the functionality of the customizable -->
              <!-- <span *ngIf='!isNonConnectedUser' i18n="@@device-settings.customizable-button-desc-changed">Change the functionality of the customizable
              button<strong> on Windows* and Windows* 10 devices</strong></span> -->
              
              <!-- Fix for IIT2-1834 starts-->
              <span *ngIf='!isNonConnectedUser' i18n="@@device-settings.customizable-button-desc-changed">Change the functionality of the customizable button on <strong>all Windows* devices</strong></span>
              <!-- Fix for IIT2-1834 ends-->
          </div>
          <div class="check_groups" id="btnAnimationMainDiv">
            <legend class="col-form-label"><span i18n="@@device-settings.button-animation">Button Animation</span>
            </legend>
            <div class="custom-control custom-switch" id="btnStatusAnimation">
              <input type="checkbox" class="custom-control-input" id="buttonAnimation"
                (click)="customizableButton($event,'status')" name="displayButton" />
              <label class="custom-control-label" for="buttonAnimation">
                {{statusAnimation}}
              </label>
            </div>
          </div>
          <div class="check_groups"id="checkGrp">
            <legend class="col-form-label">
              <span i18n="@@device-settings.button-functionality">Button Functionality</span>
            </legend>
            <div class="form-check" id="frmCheck">
              <input class="form-check-input" type="radio" name="BtnFunctionRadio" id="deviceSpecs" value="" checked
                (click)="customizableButton('device_specification','buttonFunc1')" />
              <label class="form-check-label" for="deviceSpecs">
                <span i18n="@@settings.check-groups.explore-this-device">Explore this device</span>
              </label>
            </div>
            <div class="form-check mt-2" id="linkToURL">
              <input class="form-check-input" type="radio" name="BtnFunctionRadio" id="linkToURL" value=""
                (click)="customizableButton('url','buttonFunc2')" />
              <label class="form-check-label" for="linkToURL">
                <span i18n="@@device-settings.link-to-url-title">Link to URL</span>
              </label>
            </div>
            <div class="mt-4" id="linkToURLDesc">
              <span i18n="@@device-settings.link-to-url-desc">Display a summary of this device’s specifications.</span>
            </div>
          </div>
          <div class="check_groups" id="btnGrCopy">
            <legend class="col-form-label"><span i18n="@@device-settings.button-copy">Button Copy</span></legend>
            <div *ngIf='isdefault' id="explorePCRadioMain">
              <div class="form-check" id="explorePCRadioFrmCheck">
                <input class="form-check-input" type="radio" name="BtnCopyRadio" id="explorePCRadio" value="" checked
                  (click)="customizableButton('EXPLORE THIS PC','buttonCopy')" />
                <label class="form-check-label" for="explorePCRadio">
                  <span i18n="@@device-settings.explore-this-pc">“Explore This PC”</span>
                </label>
              </div>
              <div class="form-check mt-2" style="display: flex; align-items: center" id="myBtnCopyMain">
                <input #inputbutton class="form-check-input" type="radio" name="BtnCopyRadio" id="myBtnCopy" value=""
                  (click)="customizableButton(getInputCopy,'buttonCopyInput')" />
                <input maxlength="20" [disabled]='isButtonCopyInputEnabel' class="form-control button-style" type="text" [placeholder]="buttonCopyPlaceHolder"
                  [(ngModel)]='getInputCopy' (input)="customizableButton(getInputCopy,'buttonCopyInput')" />
              </div>
            </div>
            <div *ngIf='!isdefault' class="form-group" id="websiteUrlFrmCheck">
              <div class="form-group" id="websiteURLFrmGrp">
                <div class='margin' id="settingWebsiteURL"> <span i18n="@@device-settings.website-url">Website URL</span> <span
                    class='required'>*</span></div>
                <input (keyup)="validateURL($event)" [(ngModel)]='websiteData' class="form-control" type="text"
                  [placeholder]="websiteUrlPlaceHolder">
                <span class="text-danger" *ngIf="!isWebsiteDataValid" [innerHTML]='emailValidationMsg'></span>
              </div>
              <div class="form-group" id="customBtnCopyMain">
                <div class='margin' id="customBtnCopyChild"><span i18n="@@device-settings.custom-button-copy">Custom Button Copy</span><span
                    class='required'>*</span></div>
                <input (keyup)='checkInput()' [(ngModel)]='customButton' class="form-control" type="text"
                  [placeholder]="buttonCopyPlaceHolder">
              </div>
            </div>
          </div>
        </div>
        <figure class="figure">
          <img class="figure-img" alt="custom btn eg." />
          <figcaption class="figure-caption">
            <span i18n="@@device-settings.example-desc"><strong>Example: </strong>Customize if this button will be clickable.</span>
          </figcaption>
        </figure>
      </div>
      <button type="button" [disabled]='(sendButton || !isWebsiteDataValid) || !isRetailerId || buttonCopy === ""' (click)='updateCustomizableButton()'
        class="btn btn-primary gtmDeviceUpdateCustomBtn">
        <span i18n="@@device-settings.update-custom-button">Update Customizable Button</span>
      </button>
    </div>
  </div>

  <div class="settings_block" id="settingsBlock">
    <div class="settings_headers" id="settingsHeaders">
      <img class="header_icon promoBagImg" alt="Promos" />
      <span i18n="@@promo-content.promo-content-heading">PROMOTIONAL CONTENT</span>
    </div>
    <div class="settings_body" id="pushPromos">
      <div class="mb-3">
        <span>{{globalconst.PROMO_DEVICE_TEXT}}</span>
      </div>
      <iposcen-push-promos></iposcen-push-promos>
    </div>
  </div>
  <!--Commenting below code for now, might be removed in future-->
  <!-- Idle Experience -->
  <!-- <div class="settings_block" id="idleExpBlock">
    <div class="settings_headers" id="idleExpHeaders">
      <img class="header_icon" alt="Idle Experience" />
      <span i18n="@@device-settings.idle-experience-title">Idle Experience</span>
    </div>
    <div class="settings_body" id="idleExpBody">
      <div class="setting_info" id="settingInfo">
        <span i18n="@@device-settings.idle-experience-desc">Edit the idle experience <strong>on all
            devices.</strong></span>
      </div>
      <div class="form-group mb-4" id="frmGrpIdleTime">
        <label for="idleTime"><span i18n="@@device-settings.time-untile-idle">Time Until Idle</span></label>
        <select class="form-control" id="idleTime" (change)='customizableButton($event,"time")'>
          <option value='30'>{{globalconst.THIRTY_SEC}}</option>
          <option value='45'>{{globalconst.FORTYFIVE_SEC}}</option>
          <option value='60'><span>{{globalconst.ONE_MINUTE}}</span></option>
          <option value='90'><span>{{globalconst.ONE_AND_HALF_MINUTE}}</span></option>
          <option value='120' selected><span i18n="@@device-settings.2-minutes">2 Minutes</span></option>
          <option value='300'><span i18n="@@device-settings.5-minutes">5 Minutes</span> </option>
          <option value='600'><span i18n="@@device-settings.10-minutes">10 Minutes</span> </option>
          <option value='1200'><span>20 Minutes</span> </option>
        </select>
      </div>
      <div class="idle_display_content" id="idleDisplayCon">
        <div class="mb-3 font-weight-bold" id="settingsIdleDisplay"><span i18n="@@device-settings.idle-display">Idle Display</span></div>

        
        <div class="form-check mb-3" id="fTagRotationfrmChck">
          <input class="form-check-input" type="radio" name="IdleExperience" id="fTagRotation" value=""
            [checked]="!isAttractorLoopRadionBtn" checked (click)="customizableButton('Fact Tag Rotation','factTag')" />
          <label class="form-check-label xyz" for="fTagRotation">
            <span i18n="@@device-settings.fact-tag-rotation-title">Fact tag rotation</span>
            <br />
            <div class="carbonhue"><span i18n="@@device-settings.fact-tag-rotation-title-desc">Tiles on the home page will highlight, followed by Burn-in Video, OEM Attract Loop video (if available), Logo content group (if available) and Segment content group (if available).</span></div>
          </label>
        </div>
        <div class="form-check row_indented mb-4" *ngIf="!isAttractorLoopRadionBtn" id="increaseRotationDiv">
          <input class="form-check-input" type="checkbox" id="increaseRotation" value=""
            [checked]="isincreasePromotionRotation" (click)="isPromotionRotation($event)" />
          <label class="form-check-label" for="increaseRotation">
            <span i18n="@@device-settings.increase-promotion-rotation">Increase promotion rotation</span>
            <br />
            <div class="carbonhue" id="increasePromotionDesc"><span i18n="@@device-settings.increase-promotion-rotation-desc">The custom promo(s)
                that you create will play, along with the experience of Fact Tag rotation.</span></div>
          </label>
        </div>
        
        <div class="form-check mb-3" id="attractLoopDiv">
          <input class="form-check-input" type="radio" name="IdleExperience" value=""
            [checked]="isAttractorLoopRadionBtn" id="attractLoop"
            (click)="customizableButton('AttractLoop','attractloop')" />
          <label class="form-check-label" for="attractLoop">
            <span i18n="@@device-settings.attractor-loop">Attract Loop</span>
            <br />
            <div class="carbonhue" id="attractorLoopDescLine1Main">
              <div id="attractorLoopDescLine1Child">
                <span i18n="@@device-settings.attractor-loop-desc-line1">A creative, looping experience designed to
                  attract attention which includes Burn-in Video and OEM Attract Loop Video (if available).</span>
              </div>
            </div>
          </label>
        </div>
        
        <div id="DSLoopAccDiv">
          <div class="accordion" id="DSLoopAccordion" *ngIf="isAttractorLoopRadionBtn">
            <div i18n="@@device-settings.desc.attract-loop-push-note" class="push-update-note" *ngIf="isAttractLoopRecordFound" id="pushUpdateNote">Only connected devices with IPOS versions 22CY3.0.0 or later can receive Attract Loop push updates.</div>
            <iposcen-profile-attract-loop [selectedAttractLoopId]="selectedAttractLoopId" (getAttractLoopRecordCount)="getAttractLoopRecordCount($event)"
              (getSelectedAttractLoopData)="getSelectedAttractLoopData($event)">
            </iposcen-profile-attract-loop>
          </div>

          <button [disabled]='!isRetailerId || !buttonEnabel' (click)='sendAttractLoop()' type="button"
            class="btn btn-primary gtmDevicesUpdateIdleExp">
            <span i18n="@@device-settings.update-idle-experience">Update Idle Experience</span>
          </button>
        </div>
      </div>
    </div>
  </div> -->
  <!-- uncommented for IIT2-10797-->
  <iposcen-password-popup #profileChangePasswordModal></iposcen-password-popup>

  <!-- popup -->
  <div class="container" id="container">
    <div class="modal-dialog-centered" *ngIf="openModalPopup" id="modalDialogCentered">
      <div class="modal-backdrop show" id="modalBackdrop"></div>
      <div class="modal" id="myModalSuccess">
        <div class="modal-dialog" id="myModalSuccessDialog">
          <div class="modal-content" id="myModalSuccessCon">
            <div _ngcontent-fjy-c198="" class="close" (click)="closePopup()" id="myModalSuccessClose"><img _ngcontent-fjy-c198="" alt="close"
                class="modal-close-icon"></div>
            <div class="modal-body" id="myModalSuccessBody">
              <div class="action_on_pending_user" id="actionOnPendingUsr">
                <span class="success_img"></span>
              </div>
              <div class="action-success-msg" id="actionSuccessMsg">
                <span>{{successMessage}}</span>
              </div>
              <div class="card_desc" id="cardDesc">
                <span>{{description}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="blur" *ngIf="showRetailGif" id="showRetailGifDiv">
    <div class="progress-loader" id="progressLoader">
        <div class="card-loading" id="cardLoading">
            <div class="card-spinner" id="cardSpinner">
                <div class="spinner-border text-primary" [ngClass]="{'loader':showRetailGif}" role="status" id="spinnerBorder">
                    <span class="visually-hidden loading-message"></span>
                </div>
            </div>
            <div class="switch-text" id="switchingRetailHQ"><span i18n="@@ipos-spinner-overlay.switching-retail-hq">Switching Retail HQ</span></div>
        </div>
    </div>
    </div>